import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { startWith, Subscription } from 'rxjs';
import { LearnerDetail } from 'src/app/models/learner-detail.model';
import { FormatUtil } from 'src/app/utils/format.util';
import { birthYearValidatorPattern, emailValidatorPattern, phoneValidatorPattern } from 'src/app/utils/validators.util';
import { CourseService, uniqueEmailValidator } from '../../services/course/course.service';
import { CourseTrainingProgramDetails } from 'src/app/models/course-training-program-details.model';
import { EligibilityCheckerComponent } from '../eligibility-checker/eligibility-checker.component';

@Component({
    selector: 'app-learner-detail',
    templateUrl: './learner-detail.component.html',
    styleUrls: ['./learner-detail.component.scss'],
    standalone: false
})
export class LearnerDetailComponent implements OnInit, OnChanges, OnDestroy {
  expanded = false;
  eligCheckerExpanded = false;
  newTeamMemberForm: FormGroup;

  @Input() showEligibilityChecker: boolean = false;
  @Input() learnerDetail: LearnerDetail = new LearnerDetail('');
  @Input() learnerNumber = 1;
  @Input() singleTeamMember = false
  @Input() courseDto: CourseTrainingProgramDetails

  @Input() courseId: string;
  @Input() disableDelete: boolean = false;
  @Input() DisableSameAsPrimaryContact: boolean = false;
  @Input() learnerInforRequired: boolean = false;
  @Input() isTPEdit: boolean = false;
  @Input() isTP: boolean = false;
  @Input() currentTpUserEmail: string = '';
  
  @Output() deleteLearner: EventEmitter<number> = new EventEmitter<number>()
  @Output() copyInfoFromPrimaryContact: EventEmitter<number> = new EventEmitter<number>()
  @Output() validateEmailExists: EventEmitter<string> = new EventEmitter<string>()
  inforSameAsPC: boolean = false;
  newLearnerForm: FormGroup;
  currentLang = 'en';

  formatUtil = FormatUtil
  emailControlSub?: Subscription;

  @ViewChild('multiLearnerEligibilityChecker') eligChecker: EligibilityCheckerComponent;

  constructor(
    @Inject('CourseService') public courseService: CourseService,
    public translateService: TranslateService,
    private formBuilder: FormBuilder) {
    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang
    });
  }

  ngOnInit(): void {
    this.newLearnerForm = this.formBuilder.group({
      emailAddress: new FormControl({ value: this.learnerDetail.emailAddress!, disabled: false }, [Validators.pattern(emailValidatorPattern), this.currentTpUserEmailValidator.bind(this)],
       [uniqueEmailValidator(this.courseService, this.courseId,this.learnerDetail.emailAddress!)]),
      firstName: new FormControl({ value: this.learnerDetail.firstName!, disabled: false }),
      lastName: new FormControl({ value: this.learnerDetail.lastName!, disabled: false }),
      phone: new FormControl({ value: this.learnerDetail.phoneNumber, disabled: false }, [Validators.pattern(phoneValidatorPattern)]),
      //@ts-ignore
      birthYear: new FormControl({ value: this.learnerDetail.birthYear, disabled: false }, [Validators.pattern(birthYearValidatorPattern)]),
      optinForEmail: new FormControl({ value: this.learnerDetail.optinforEmail, disabled: false }),
      optinForSMS: new FormControl({ value: this.learnerDetail.optinforSMS, disabled: false }),
      updateOn: 'blur'
    });

    this.inforSameAsPC = false;

    this.expanded = this.learnerNumber < 2 || this.isTPEdit;

    const emailControl = this.newLearnerForm.controls['emailAddress'];
    this.emailControlSub = emailControl.valueChanges.pipe(startWith(emailControl.value)).subscribe(() => {
      this.validateCurrentTpUserEmail();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.newLearnerForm) return;

    if (changes['currentTpUserEmail'] || changes['isTP']) {
      this.newLearnerForm.controls['emailAddress'].updateValueAndValidity({ emitEvent: false });
      this.validateCurrentTpUserEmail();
    }
  }

  ngOnDestroy(): void {
    this.emailControlSub?.unsubscribe();
  }

  private currentTpUserEmailValidator(control: AbstractControl) {
    const emailValue = (control.value ?? '').toString().trim().toLowerCase();
    const tpEmail = (this.currentTpUserEmail ?? '').toString().trim().toLowerCase();

    if (this.isTP && emailValue && tpEmail && emailValue === tpEmail) {
      return { currentTpUser: true };
    }

    return null;
  }

  private validateCurrentTpUserEmail() {
    const emailControl = this.newLearnerForm?.controls?.['emailAddress'];
    if (!emailControl) return;

    if (emailControl.hasError('currentTpUser')) {
      emailControl.markAsTouched();
      emailControl.markAsDirty();
    }
  }

  DeleteLearner() {
    this.deleteLearner.emit(this.learnerNumber);
  }

  CopyInfoFromPrimaryContact(checked: any) {
    if (checked) {
      this.copyInfoFromPrimaryContact.emit(this.learnerNumber);
      this.inforSameAsPC = true;
      this.newLearnerForm.markAsDirty();
      this.validateCurrentTpUserEmail();
    }
    else {
      this.ClearCheckBox();
    }
  }

  ClearCheckBox() {
    this.inforSameAsPC = false;
    this.newLearnerForm.markAsDirty();
    this.validateCurrentTpUserEmail();
  }

  markAllControlsAsTouched(): void {
    this.newLearnerForm.markAllAsTouched();
  }
  
}

